import { create } from 'zustand';
import type { PlayheadState } from '../types';

interface PlayheadStore extends PlayheadState {
  setCurrentTime: (ms: number) => void;
  setPlaying: (playing: boolean) => void;
  advance: (deltaMs: number) => void;
}

export const usePlayheadStore = create<PlayheadStore>((set) => ({
  currentTimeMs: 0,
  playing: false,

  setCurrentTime: (ms) => set({ currentTimeMs: Math.max(0, ms) }),
  setPlaying: (playing) => set({ playing }),
  advance: (deltaMs) => set((s) => ({ currentTimeMs: s.currentTimeMs + deltaMs })),
}));
